import { setContext } from '@apollo/client/link/context';
import { LOGIN_METHOD_HEADER_NAME } from '@common/neo.tax';

import { getAuthenticationToken } from '@neo.tax/shared/third-parties';
import { env, getActiveLoginMethod } from '@neo.tax/shared/utils';

export const authLink = setContext(async (_, { prevHeaders }) => {
  const headers = { ...prevHeaders };
  const token = await getAuthenticationToken();

  headers.version = env.REACT_APP_VERSION;
  if (token) {
    headers.authorization = `Bearer ${token}`;
  }
  // Carry the magic-link hint to the auth guard during the brief fresh-login window. A header (not a
  // cookie) because the API is cross-origin in every environment — see login-method-header.ts.
  const loginMethod = getActiveLoginMethod();
  if (loginMethod) {
    headers[LOGIN_METHOD_HEADER_NAME] = loginMethod;
  }
  return { headers };
});
